import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  fileUploadBox: {
    position: 'relative',
    padding: theme.spacing(2),
    color: theme.palette.text.hint,
    transition: 'background-color 0.3s, color 0.3s, transform 0.3s',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}0f`,
      transform: 'translate(0px, 1px)',
      color: theme.palette.primary.light,
    },
    maxHeight: '207px',
    display: 'flex',
  },
  fileUploadIcon: {
    width: '150px',
    height: '100px',
  },
  previewImageWrap: {
    minWidth: '175px',
    minHeight: '175px',
    marginRight: '20px',
    display: 'flex',
    border: '2px dashed #ccc',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    height: '100%',
  },
  previewImage: {
    width: '100%',
    objectFit: 'contain',
  },
  alignCenter: {
    textAlign: 'center',
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
}));

export default useStyles;
